@if (assistant.previewFile(); as file) {
  <app-modal
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
    [title]="file.title"
    [size]="ModalSize.XXL"
    [config]="config()"
    (closeModal)="assistant.closePreview()">
    <iframe
      modal-body
      sandbox="allow-scripts"
      class="border-weak block h-[75vh] w-full rounded-sm border bg-white"
      [title]="'assistant.files.preview_frame' | translate"
      [srcdoc]="documentHtml()"></iframe>
  </app-modal>
}
